import {initSearchForm} from '../components/search/searchForm.js'

await initSearchForm()
